import { produce } from "immer";
import {
  FETCH_DISCREPANCY,
  FETCH_DISCREPANCY_SUCCESS,
  FETCH_DISCREPANCY_FAILURE,
  UPDATE_FILTERS,
  UPDATE_WEEK,
  TOGGLE_MODAL,
  APPROVE_CLOCK,
  APPROVE_CLOCK_SUCCESS,
  APPROVE_CLOCK_FAILURE,
  UPDATE_LIST,
  TOGGLE_UNAPPROVE,
} from "./constants";
import { getCurrentWeek } from "../../utils/dates";

export const initialState = {
  isFetchingDiscrepancy: false,
  discrepancyList: [],
  discrepancyEditList: [],
  filters: {
    from_date: "",
    to_date: "",
    location_id: "",
    extra_time_approval_requested: "All",
    status: "All",
  },
  week: {},
  approveModal: {
    open: false,
  },
  isApproving: false,
  unapproveModal: {
    open: false,
  },
};

const DiscrepancyReducer = (state = initialState, action) =>
  produce(state, (draft) => {
    switch (action.type) {
      case FETCH_DISCREPANCY:
        draft.isFetchingDiscrepancy = true;
        draft.discrepancyList = [];
        draft.discrepancyEditList = [];
        break;
      case FETCH_DISCREPANCY_SUCCESS:
        draft.isFetchingDiscrepancy = false;
        draft.discrepancyList = action.payload;
        draft.discrepancyEditList = action.payload;
        break;
      case FETCH_DISCREPANCY_FAILURE:
        draft.isFetchingDiscrepancy = false;
        draft.discrepancyList = [];
        draft.discrepancyEditList = [];
        break;

      case UPDATE_LIST:
        draft.discrepancyEditList = action.payload;
        break;

      case UPDATE_FILTERS:
        draft.filters = action.payload;
        break;

      case UPDATE_WEEK:
        draft.week = action.payload;
        break;

      case TOGGLE_MODAL:
        draft.approveModal = action.payload;
        break;

      case TOGGLE_UNAPPROVE:
        draft.unapproveModal = action.payload;
        break;

      case APPROVE_CLOCK:
        draft.isApproving = true;
        break;
      case APPROVE_CLOCK_SUCCESS:
        draft.isApproving = false;
        break;
      case APPROVE_CLOCK_FAILURE:
        draft.isApproving = false;
        break;

      default:
        return state;
    }
  });

export default DiscrepancyReducer;
